<template>
  <div class="q-pa-md" style="max-width: 560px; margin: 0 auto">
    <q-card>
      <q-card-section>
        <div class="text-h5 q-mb-md">Регистрация партнёра</div>
        <q-banner v-if="hasAnyErrors" class="bg-orange-1 text-orange-9 q-mb-md" rounded>
          Ошибка валидации. Проверьте правильность введённых данных и попробуйте снова.
        </q-banner>
        <q-form @submit.prevent="submit">
          <q-input
            v-model="form.name"
            label="Имя / название"
            outlined
            dense
            :error="!!form.errors.name"
            :error-message="form.errors.name"
            class="q-mb-md"
          />
          <q-input
            v-model="form.email"
            label="Email"
            type="email"
            autocomplete="email"
            outlined
            dense
            :error="!!form.errors.email"
            :error-message="form.errors.email"
            class="q-mb-md"
          />
          <q-input
            v-model="form.password"
            label="Пароль"
            type="password"
            autocomplete="new-password"
            outlined
            dense
            :error="!!form.errors.password"
            :error-message="form.errors.password"
            class="q-mb-md"
          />
          <q-input
            v-model="form.password_confirmation"
            label="Повторите пароль"
            type="password"
            autocomplete="new-password"
            outlined
            dense
            class="q-mb-md"
          />

          <div class="row items-center q-col-gutter-sm">
            <div class="col">
              <a :href="route('partner.login')" class="text-primary">Уже есть аккаунт? Войти</a>
            </div>
            <div class="col-auto">
              <q-btn color="primary" label="Зарегистрироваться" type="submit" :loading="form.processing" no-caps />
            </div>
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </div>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { computed } from 'vue'

const form = useForm({
  name: '',
  email: '',
  password: '',
  password_confirmation: '',
})

const hasAnyErrors = computed(() => Object.keys(form.errors || {}).length > 0)

const submit = () => {
  form.post(route('partner.register.store'))
}
</script>

